// @ts-ignore
import jalaali from 'jalaali-js';
import moment from 'jalali-moment';
import { errorHandler } from 'utils'
import { isNullOrEmpty } from './isNullOrEmpty';

export const today = (separator: string = '/'): string => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  const year = today.getFullYear();

  return `${year}${separator}${month}${separator}${day}`;
}

export const todayJalali = (): string => {
  return (
    moment(today(), 'YYYY/MM/DD')
      .locale('fa')
      .format('YYYY/MM/DD')
  );
}

export const getJalaliDate = (
  gregorianDate: any, separator: string = '/', hasTime: boolean = false
): string => {
  if (isNullOrEmpty(gregorianDate)) return ''

  if (typeof gregorianDate === 'string') {
    const format = hasTime
      ? `hh:mm YYYY${separator}MM${separator}DD`
      : `YYYY${separator}MM${separator}DD`
    return (
      moment(gregorianDate, 'YYYY/MM/DD hh:mm')
        .locale('fa')
        .format(format)
    )
  }
  try {
    const jalali = jalaali.toJalaali(gregorianDate)
    return (
      jalali.jy + separator +
      jalali.jm + separator + 
      jalali.jd
    )
  } catch (e) {
    errorHandler(e)
    return ''
  }
}

export const getJalaliLastWeek = (): string => {
  const today = new Date()
  const past = today.getDate() - 7
  today.setDate(past)
  return getJalaliDate(today)
}

export const toGregorian = (
  shamsiDate: string, separator: string = '-'
): string => {
  if (!shamsiDate) return ''
  const shamsiDateArray = shamsiDate.split('/')
  const gregorianDate = jalaali.toGregorian(
    Number(shamsiDateArray[0]),
    Number(shamsiDateArray[1]),
    Number(shamsiDateArray[2])
  )
  return (
    gregorianDate.gy + separator +
    gregorianDate.gm + separator +
    gregorianDate.gd
  )
}

export default jalaali;
